const env = import.meta.env.VITE_APP_ENV;

export function StagingWatermark() {
  if (!env) return null;

  const label = env.toUpperCase();

  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        pointerEvents: "none",
        backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
          `<svg xmlns='http://www.w3.org/2000/svg' width='300' height='300'>` +
            `<text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' ` +
            `transform='rotate(-45, 150, 150)' ` +
            `font-family='sans-serif' font-size='28' font-weight='bold' fill='red' opacity='0.10'>` +
            `${label}` +
            `</text></svg>`,
        )}")`,
        backgroundRepeat: "repeat",
      }}
    />
  );
}
